import { Box, useMediaQuery } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import LanguageMenu from "./LanguageMenu"
import { useTranslation } from "react-i18next"
import { STATICS } from "api/api"
import {ReactComponent as EstateToolLogo} from '/src/assets/svg/estatetool-logo.svg'
import { useEffect, useState } from "react"

export const Maintenance = () => {
    const { i18n, i18n: { language } }        = useTranslation()
    const [viewportHeight, setViewportHeight] = useState(0);
    const isTabletOrAbove                     = useMediaQuery('(min-width:600px)');

    useEffect(() => {
          // Function to update the viewport height
        const updateViewportHeight = () => {
        setViewportHeight(window.innerHeight);
        };
    
          // Set the viewport height on load
        updateViewportHeight();
    
          // Add resize event listener
        window.addEventListener("resize", updateViewportHeight);
    
          // Cleanup the event listener on unmount
        return () => {
        window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    return <Box sx = {{ position: 'relative', height: isTabletOrAbove ? '100%' : '150vh' }}>
    <Box   sx      = {{ 
                    position: 'fixed',
                    width   : '100%',
                    height  : viewportHeight
                    }}>
                    <Box sx={{
                        pt           : { xs:2, lg: 5 }, px: { xs:2, lg: 5 },
                        height       : "100%",
                        display      : "flex",
                        flexDirection: "column"
                        }}>
                    <Box sx = {{ display: 'flex', alignContent: 'center', justifyContent: "space-between" }}>
                    <Box sx = {{ height: { xs: 50, lg: 109 }, width: { xs: 100, lg: 229 },
                          '@media (min-width: 600px) and (max-height: 1000px)': {
                                               height: "100%",
                                               width : "130px"
                                    } }}>
                                <EstateToolLogo style = {{ width: '100%', height: '100%' }} />
                            </Box>
                        <Box sx = {{ position: 'relative', height: '100%'}}>
                            <LanguageMenu />
                            </Box>
                        </Box>
                        <Box sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', height: "100%", justifyContent: "space-between", pt: { xs:2, lg: 0 } }}>
                        <Box sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', gap: '40px' }}>
                        <Box sx = {{ display: 'flex', justifyContent: 'center' }}>
                                    <Box
                                        component = "img"
                                        sx        = {{
                                                width                      : '998px',
                                                height: '100%',
                                                fontSize: 0,
                                                '@media (min-width:1140px)': {
                                                    width   : '100%',
                                                    maxWidth: '1000px'
                                                },
                                                '@media (max-width:1140px)': {
                                                    width: 'calc(100% - 80px)',
                                                },
                                                '@media (max-width:800px)': {
                                                    width: 'calc(100% - 40px)',
                                                },
                                                '@media (max-width:600px)': {
                                                    width: 'calc(100% - 20px)',
                                                },
                                                '@media (max-width:500px)': {
                                                    width: '100%',
                                                },
                                                '@media (min-width: 600px) and (max-height: 1000px)': {
                                                    height   : 'calc(100vh - 400px)',
                                                    minHeight: '30px'
                                                },
                                            }}
                                        alt = ""
                                        src = {`${STATICS}svg/maintenance-image.svg`}
                                    />
                                </Box>
                                <Box sx        = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '16px' }}>
                                <h1  className = {isTabletOrAbove ? 'h1' : `h3`}>{ maintenancePage.desc[language] }</h1>
                                <Box className = "paragraph1-regular" sx = {{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '30px', maxWidth: "770px", alignSelf: 'center' }}>
                                        <p>{ maintenancePage.p1[language] }</p>
                                        <p>{ maintenancePage.p2[language] }</p>
                                    </Box>
                                </Box>
                            </Box>
                            <PoweredBy />
                        </Box>
                    </Box>
                </Box>
    </Box>
}



const maintenancePage = {
    desc: {
        "en": "We're polishing the details!",
        "da": "Vi finpudser detaljerne!"
    },
    p1: {
        "en": "The site is temporarily under maintenance while we work to improve your experience. We are updating and optimizing our property selector, so you will soon have access to an even better version.",
        "da": "Siden er midlertidigt under vedligeholdelse, mens vi arbejder på at forbedre din oplevelse. Vi opdaterer og optimerer vores boligvælger, så du snart får adgang til en endnu bedre version."
    },
    p2: {
        "en": "Thank you for your patience - we'll be back soon, and it will definitely be worth the wait!",
        "da": "Tak for din tålmodighed - vi er snart tilbage, og det bliver helt sikkert ventetiden værd!"
    }
}